import {
  type ApproveEntitySuggestionRequest,
  type ApproveEntitySuggestionResponse
} from '@bliks-io/contracts';
import {
  invalidateSuggestionResolutionSurfaces,
  useEntitySuggestionAction
} from './useEntitySuggestionAction';

export function useApproveEntitySuggestion(suggestionId: string) {
  return useEntitySuggestionAction<ApproveEntitySuggestionRequest, ApproveEntitySuggestionResponse>(
    {
      suggestionId,
      verb: 'approve',
      // Approval creates the entity and rewrites suggestion→entity refs across
      // all read surfaces — exactly like a merge.
      extraInvalidations: (qc) => invalidateSuggestionResolutionSurfaces(qc, { entityLists: true })
    }
  );
}
